import type { EvaluationSubjectKind } from '../../../services/api/evaluation-template.api.js';

/**
 * A subject kind is one of the eleven entity types now (ENTITY-MODEL-PLAN.md §2.1) — the server
 * enum is `entity_type`, so free text is a guaranteed 400. Declaring it as a `Record` over the
 * generated union makes a missing kind a compile error rather than a silently short menu.
 */
export const SUBJECT_KIND_LABELS: Record<EvaluationSubjectKind, string> = {
  agent_template: 'Agent template',
  workflow: 'Workflow',
  workforce: 'Workforce',
  skill: 'Skill',
  tool: 'Tool',
  strategy: 'Strategy',
  strategy_template: 'Strategy template',
  bucket: 'Bucket',
  indicator: 'Indicator',
  mutation_recipe: 'Mutation recipe',
  evaluation_template: 'Evaluation template',
};

export const SUBJECT_KIND_OPTIONS = (Object.keys(SUBJECT_KIND_LABELS) as EvaluationSubjectKind[]).map((value) => ({
  value,
  label: SUBJECT_KIND_LABELS[value],
}));

export const TEMPLATE_KIND_OPTIONS = [
  { value: 'leaf', label: 'Leaf: direct criteria' },
  { value: 'group', label: 'Group: composed from child templates' },
];

export const VISIBILITY_OPTIONS = [
  { value: 'private', label: 'Private: only you' },
  { value: 'org', label: 'Org: everyone in this organization' },
];
